module.exports = __webpack_public_path__ + "img/4816.a157bde3.jpg";